import styled from '@emotion/styled';
import { space } from 'folio-common-components';
import { invariant } from 'folio-common-utils';
import * as React from 'react';
import type { MaBankSelection } from '../../../gqltypes';
import { setBankSelection } from '../../../services';
import { useActions, useSelector } from '../../../state';
import { Button } from '../../buttons';
import { PageHeading } from '../../page-heading';
import { Pitch } from '../../pitch';

const Section = styled.div`
  ${space([32], 'margin-top')};
`;

const Heading = PageHeading.withComponent('h3');

export const OtherBankStep: React.FC = () => {
  const { id, willHaveEmployees } = useSelector(e => ({
    id: e.founding.id,
    willHaveEmployees: e.founding.foundingDetails?.willHaveEmployees,
  }));
  const { foundingActions } = useActions();
  const onSetBankSelection = async (selection: MaBankSelection) => {
    await setBankSelection({ id, selection });
    foundingActions.updateFounding({
      bankSelection: selection,
    });

    // This will show another screen, but not change the URL
    // so we have to scroll manually.
    window.scrollTo(0, 0);
  };

  invariant(willHaveEmployees, 'Expected an employee question to be defined');

  return (
    <>
      <PageHeading>Er du helt sikker?</PageHeading>

      <p>
        Det går raskere å stifte selskapet hvis du åpner bank&shy;kontoen
        gjennom denne prosessen.
      </p>

      <p>
        Folio er vår samarbeids&shy;partner som leverer bank&shy;konto. Du får
        konto kjappere, og slipper skaffe dokumenter fra banken.
      </p>

      <Heading css={space([48], 'margin-top')}>
        Fiken + Folio gir mange fordeler:
      </Heading>

      <Pitch willHaveEmployees={willHaveEmployees} />

      <Section>
        <p>
          <Button
            fullWidth={true}
            size="large"
            onClick={() => onSetBankSelection('UNSET')}
          >
            Jeg vil prøve Folio likevel
          </Button>
        </p>
        <p>
          <Button
            fullWidth={true}
            level="secondary"
            size="large"
            onClick={() => onSetBankSelection('OTHER_NAGGED')}
          >
            Nei takk, jeg er helt sikker
          </Button>
        </p>
      </Section>
    </>
  );
};
